module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-Add_1.2bc9632a.jpg";